module.exports = __webpack_public_path__ + "img/1626685917.80dd46bf.jpg";